<template>
  <main id="content" role="main" class="bg-light">


    <div class="container space-1">
      <i class="fa fa-arrow-left text-primary" aria-hidden="true"></i>
      <a href="./moncompte.html" title="retour">Retour</a>
    </div>


    <!-- Content Section -->
    <div class="container space-1 space-top-lg-0 space-bottom-lg-2">
      <div class="row">
        <div class="col-lg-3">
          <!-- Navbar -->
          <div class="navbar-expand-lg navbar-expand-lg-collapse-block navbar-light">
            <div id="sidebarNav" class="collapse navbar-collapse navbar-vertical">
              <!-- Card -->
              <div class="card mb-5">
                <div class="card-body">


                  <!-- Nav -->
                  <h5 class="text-cap small text-uppercase text-danger">Mes informations</h5>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">

                    <li class="nav-item">
                      <a class="nav-link" :class="{active: current_tab == 0}" href="javascript:;" @click="current_tab = 0">
                        <i class="fas fa-cog nav-icon"></i> Mes informations personnelles
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link " href="./preferences.html">
                        <i class="fas fa-sliders-h nav-icon"></i> Paramètrage de la plateforme
                      </a>
                    </li>


                    <li class="nav-item">
                      <a class="nav-link" href="./e-card-account.html">
                        <i class="fas  fa-id-card   nav-icon"></i>Mon e-Pass
                      </a>
                    </li>


                    <li class="nav-item">
                      <a class="nav-link " href="./reservations.html">
                        <i class="fas fa-book nav-icon"></i> Réservations
                      </a>
                    </li>

                    <li class="nav-item">
                      <a class="nav-link" href="./sortielikes.html">
                        <i class="fas fa-heart nav-icon"></i> Mes Favoris
                      </a>
                    </li>





                  </ul>
                  <!-- End List -->

                  <h6 class="text-cap small text-uppercase text-danger">Mes participations</h6>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">



                    <li class="nav-item">
                      <a class="nav-link" :class="{active: current_tab == 1}" href="javascript:;" @click="current_tab = 1">
                        <i class="fas fa-heart nav-icon"></i> Taxe d'apprentisssage
                      </a>
                    </li>




                    <li class="nav-item">
                      <a class="nav-link " href="./groupe_participation.html">
                        <i class="fas fa-donate nav-icon"></i> Documents partagés
                      </a>
                    </li>


                    <li class="nav-item">
                      <a class="nav-link" href="./ideesproposees.html">
                        <i class="fas  fa-id-card   nav-icon"></i>Mes propositions de sorties
                      </a>
                    </li>


                  </ul>
                  <!-- End List -->


                  <h6 class="text-cap small text-uppercase text-danger">
                    Aide</h6>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">

                    <li class="nav-item">
                      <a class="nav-link" href="./envoyer-invitation.html">
                        <i class="fas fa-fighter-jet nav-icon"></i>Envoyer une invitation
                        <span class="badge badge-soft-dark badge-pill nav-link-badge">1</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="./contact-account.html">
                        <i class="fas fa-phone nav-icon"></i> Contacter le support
                      </a>
                    </li>



                  </ul>
                  <!-- End List -->



                  <div class="dropdown-divider"></div>

                  <!-- List -->
                  <ul class="nav nav-sub nav-sm nav-tabs nav-list-y-2">

                    <li class="nav-item">
                      <a class="nav-link text-danger" href="./deleteaccount.html">
                        <i class="fas fa-ban nav-icon"></i> Suppression de compte
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link text-primary" href="disconnect.html">
                        <i class="fas fa-sign-out-alt nav-icon"></i> Me deconnecter
                      </a>
                    </li>
                  </ul>
                  <!-- End List -->

                  <!-- End Nav -->
                </div>
              </div>
              <!-- End Card -->
            </div>
          </div>
          <!-- End Navbar -->
        </div>

<!--    Modifier infos perso-->
        <div v-if="current_tab == 0" class="col-lg-9">
          <!-- Card -->
          <div class="card mb-3 mb-lg-5">
            <div class="card-header">
              <h5 class="card-title">Modifier mes informations personnelles</h5>
            </div>

            <!-- Body -->
            <div class="card-body">



              <div class="col-lg-12">
                <label>Titre : </label>
                <div class="row ">


                  <!-- Custom Radio -->
                  <div class="col-sm-6 form-control">
                    <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="genderTypeRadio" id="genderTypeRadio1">
                      <label class="custom-control-label" for="genderTypeRadio1">Mr</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                  <!-- Custom Radio -->
                  <div class="col-sm-6 form-control">
                    <div class="custom-control custom-radio text-muted">
                      <input type="radio" class="custom-control-input" name="genderTypeRadio" id="genderTypeRadio2" checked>
                      <label class="custom-control-label" for="genderTypeRadio2">Mme</label>
                    </div>
                  </div>
                  <!-- End Custom Radio -->

                </div>
              </div>




              <div class="mb-3">
                <label for="lastNameLabel" class=" col-form-label input-label">Nom <i class="far fa-question-circle text-body ml-1" data-toggle="tooltip" data-placement="top" title="Ne divulger pas votre identité à n'importe qui"></i></label>
                <input type="text" class="form-control" name="lastName" id="lastNameLabel" placeholder="Clarice" aria-label="Clarice" value="Natalie">


              </div>


              <div class="mb-3">
                <label for="firstNameLabel" class=" col-form-label input-label">Prénom <i class="far fa-question-circle text-body ml-1" data-toggle="tooltip" data-placement="top" title="Ne divulger pas votre identité à n'importe qui"></i></label>

                <input type="text" class="form-control" name="firstName" id="firstNameLabel" placeholder="Boone" aria-label="Boone" value="Curtis">

              </div>



              <div class="mb-3">
                <label for="specialiteLabel" class=" col-form-label input-label">Spécialités <i class="far fa-question-circle text-body ml-1" data-toggle="tooltip" data-placement="top" title="Ne divulger pas votre identité à n'importe qui"></i></label>

                <input type="text" class="form-control" name="specialite" id="specialiteLabel" placeholder="Boone" aria-label="Boone" value="Curtis">

              </div>


              <div class="mb-3">
                <label for="codeEtabLabel" class=" col-form-label input-label">Code d'établissement <i class="far fa-question-circle text-body ml-1" data-toggle="tooltip" data-placement="top" title="Ne divulger pas votre identité à n'importe qui"></i></label>

                <input type="text" class="form-control" name="codeEtab" id="codeEtabLabel" placeholder="Boone" aria-label="Boone" value="Curtis">

              </div>



              <!-- Form Group -->
              <div class="row form-group">
                <label class=" col-form-label input-label">Photo Actuelle</label>
                <div class="col-sm-9">
                  <div class="media align-items-center">
                    <label class="avatar avatar-xl avatar-circle mr-4" for="avatarUploader">
                      <img id="avatarImg" class="avatar-img" src="/modules/testmaquette/img/camera.png" alt="Image Description">
                    </label>

                    <div class="media-body">
                      <div class="btn btn-sm btn-primary file-attachment-btn mb-2 mb-sm-0 mr-2">Télécharger une photo
                        <input type="file" class="js-file-attach file-attachment-btn-label" id="avatarUploader"
                               data-hs-file-attach-options='{
                                    "textTarget": "#avatarImg",
                                    "mode": "image",
                                    "targetAttr": "src",
                                    "allowTypes": [".png", ".jpeg", ".jpg"]
                                 }'>
                      </div>

                      <a class="btn btn-sm btn-white mb-2 mb-sm-0" href="javascript:;">Supprimer</a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Form Group -->


              <div class="mb-3">
                <label for="mailLabel" class=" col-form-label input-label">Adresse e-mail <i class="far fa-question-circle text-body ml-1" data-toggle="tooltip" data-placement="top" title="Ne divulger pas votre identité à n'importe qui"></i></label>

                <input type="text" class="form-control" name="mail" id="mailLabel" placeholder="Boone" aria-label="Boone" value="Curtis">

              </div>

              <div class="mb-3">
                <label for="altMailLabel" class=" col-form-label input-label">E-mail alternatif <i class="far fa-question-circle text-body ml-1" data-toggle="tooltip" data-placement="top" title="Ne divulger pas votre identité à n'importe qui"></i></label>

                <input type="text" class="form-control" name="altMail" id="altMailLabel" placeholder="Boone" aria-label="Boone" value="Curtis">

              </div>



              <!-- Toggle Switch -->
              <label class="row form-group toggle-switch mb-3" for="preferencesSwitch2">
                    <span class="col-8 col-sm-9 toggle-switch-content ml-0">
                      <span class="card-text text-dark mb-0">S'abonner aux Newletters</span>
                    </span>
                <span class="col-4 col-sm-3">
                      <input type="checkbox" class="toggle-switch-input" id="preferencesSwitch2" checked>
                      <span class="toggle-switch-label ml-auto">
                        <span class="toggle-switch-indicator"></span>
                      </span>
                    </span>
              </label>
              <!-- End Toggle Switch -->

              <!-- Toggle Switch -->
              <label class="row form-group toggle-switch mb-3" for="preferencesSwitch1">
                                  <span class="col-8 col-sm-9 toggle-switch-content ml-0">
                                    <span class="card-text text-dark mb-0">Rencontrer les partenaires culturels</span>
                                  </span>
                <span class="col-4 col-sm-3">
                                    <input type="checkbox" class="toggle-switch-input" id="preferencesSwitch1" checked>
                                    <span class="toggle-switch-label ml-auto">
                                      <span class="toggle-switch-indicator"></span>
                                    </span>
                                  </span>
              </label>
              <!-- End Toggle Switch -->
            </div>
            <!-- End Body -->

            <!-- Footer -->
            <div class="card-footer d-flex justify-content-end">
              <a class="btn btn-white" href="javascript:;">Annuler les modifications</a>
              <span class="mx-2"></span>
              <a class="btn btn-primary" href="javascript:;">Enregistrer</a>
            </div>
            <!-- End Footer -->
          </div>
          <!-- End Card -->


          <div class="card">
            <div class="card-header d-block">
              <h3>Enregistrer mes informations pour faciliter mes transactions</h3>
              <p>Je veux capter la taxe d’apprentissage et je renseigne mon RIB dans l’optique de permettre à une entreprise de me la verser
              </p>
            </div>
            <div class="card-body">
              <form class="js-validate">

                <div class="border-bottom mb-1 ">
                  <h3>Compléter mon profil</h3>
                </div>



                <!-- Form Group -->
                <div class="form-group">
                  <label for="numero_iban" class="input-label">IBAN</label>
                  <input type="email" class="form-control" name="numero_iban" id="numero_iban" placeholder="000-000-000-00000" aria-label="IBAN">
                </div>
                <!-- End Form Group -->

                <div class="row">
                  <div class="col-sm-6">
                    <!-- Form Group -->
                    <div class="form-group">
                      <label for="bic" class="input-label">Code BIC</label>
                      <input type="text" class="form-control"  name="bic" id="bic" placeholder="AGRIFRPP 000" aria-label="bic">
                    </div>
                    <!-- End Form Group -->
                  </div>
                  <div class="col-sm-6">
                    <!-- Form Group -->
                    <div class="form-group">
                      <label for="titulaire_name" class="input-label">Nom du titulaire</label>
                      <input type="text" class="form-control" name="titulaire_name" id="titulaire_name" placeholder="nom" aria-label="titulaire_name">
                    </div>
                    <!-- End Form Group -->
                  </div>


                </div>
                <!-- End Row -->


                <a class="btn btn-primary" href="#">Enregistrer les modfications</a>
              </form>
            </div>
          </div>



        </div>

<!--    Liste entreprises-->
        <div v-if="current_tab == 1" class="col-lg-9">



          <div  class="card mb-3 mb-lg-5">
            <!-- Card -->

            <!-- Header -->
            <div class="card-header d-flex-inline justify-content-between">
              <h5 class="card-header-title">Entreprise en partenariat</h5>
              <a href="../form-taxe.html" class="btn btn-primary">Ajouter une entreprise</a>
            </div>
            <!-- End Header -->

            <div class="card-body">
              <!-- Table -->
              <div class="table-responsive space-bottom-1">
                <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle">
                  <thead class="thead-light">
                  <tr>
                    <th>Nom de l'entreprise</th>

                    <th>Activité de l’entreprise</th>

                    <th>Date du dernier stage</th>
                    <th>Montant</th>
                    <th style="width: 5%;"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Bagelshtein</td>

                    <td><span class="badge badge-soft-warning">Restauration</span></td>

                    <td>22/04/2020</td>

                    <td><a class="btn btn-xs btn-white" href="javascript:;" data-toggle="modal" data-target="#invoiceReceiptModal"><i class="fas fa-eye-slash mr-1"></i> 1080 €</a></td>
                  </tr>
                  <tr>
                    <td>e-KOA</td>

                    <td><span class="badge badge-soft-success">Finance</span></td>

                    <td>22/04/2019</td>
                    <td><a class="btn btn-xs btn-white" href="javascript:;" data-toggle="modal" data-target="#invoiceReceiptModal"><i class="fas fa-eye-slash mr-1"></i> 800 €</a></td>
                  </tr>
                  <tr>
                    <td>Midas</td>

                    <td><span class="badge badge-soft-primary">Mécanique</span></td>

                    <td>22/04/2018</td>

                    <td><a class="btn btn-xs btn-white" href="javascript:;" data-toggle="modal" data-target="#invoiceReceiptModal"><i class="fas fa-eye-slash mr-1"></i> 558 €</a></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End Table -->
            </div>


            <!-- End Card -->
          </div>






        </div>
      </div>
      <!-- End Row -->
    </div>
    <!-- End Content Section -->
  </main>
</template>

<script>
export default {
  name: "DlnkTaxeCompteProf",

  data: function () {
    return {
      current_tab: 0,
    }
  }
}
</script>

<style scoped>

</style>